<!-- `row` in the banner variant, so the grid columns below sit on the same
     edges as an app-form-row's: that host IS the `.row`, whose negative side
     margins cancel the first column's gutter against the card. Without them
     this wrapper's field column started 15px right of the Store Images row's
     and ran 30px narrower, and the two bands have to line up one under the
     other at every width. `pl-0` goes with it, for the same reason — the row's
     negative margin is what pulls the label flush, so keeping pl-0 as well
     would pull it 15px further. -->
<div
  class="d-flex mb-4 flex-xl-row flex-lg-row flex-md-row flex-sm-column flex-column"
  [class.row]="isBanner"
>
  <label
    for="upload-container"
    class="d-flex col-xl-4 col-lg-4 col-md-4 col-sm-12"
    [class.pl-0]="!isBanner"
    >{{ label }}</label
  >
  <div
    id="upload-container"
    class="upload-container col-xl-8 col-lg-8 col-md-8 col-sm-12 mb-2"
  >
    <div class="d-flex flex-column">
      <div>
        <div
          class="d-inline-flex upload-reel"
          [class.no-image]="!showThumbnail"
          [class.upload-reel--banner]="isBanner"
        >
          <!-- The banner shows the stored clip itself, behind the upload icon
               and the caption. It plays, muted and looping, because that is
               what the customer will see at the top of the menu and because a
               still first frame is not painted reliably across browsers with
               no poster — a blank band would read as "nothing uploaded". -->
          <video
            *ngIf="showBannerVideo"
            class="reel-banner-video"
            [src]="currentVideoUrl"
            [muted]="true"
            autoplay
            muted
            loop
            playsinline
            disablePictureInPicture
            preload="metadata"
            data-testid="upload-banner-video"
          ></video>
          <ng-container *ngIf="!showBannerVideo">
            <div
              class="reel-banner-image"
              [style.background-image]="reelImage"
              *ngIf="showThumbnail; else contentReel"
            ></div>
            <ng-template #contentReel>
              <div class="reel-banner-image bg-white"></div>
            </ng-template>
          </ng-container>
          <div class="opacity-layer"></div>
          <i
            *ngIf="!showThumbnail"
            class="fas fa-cloud-upload-alt video-upload-icon"
          ></i>
          <span
            *ngIf="showCaption"
            id="upload-reel-txt"
            class="d-block text-center"
            >{{ captionKey | translate }}</span
          >
          <app-file-input
            inputId="uploadVideo"
            name="image"
            [accept]="acceptedFormats"
            [overlay]="true"
            (fileSelected)="uploadVideo($event)"
            (clickEvent)="selectVideo($event)"
          ></app-file-input>
          <i
            *ngIf="hasFile"
            class="fas fa-times-circle reel-remove-icon"
            [class.reel-remove-icon--on-light]="!showThumbnail"
            data-testid="upload-remove-icon"
            (click)="processRemoveVideo()"
          ></i>
        </div>
        <!-- Sits beside the tile as an inline-block sibling, so the tile's own
             layout and the video caller's spinner placement are untouched. The
             file is served as an attachment, so this downloads rather than
             previews — there is no PDF preview in the admin. -->
        <i
          *ngIf="showDownload && hasFile"
          class="fas fa-cloud-download-alt file-download-icon"
          role="button"
          tabindex="0"
          data-testid="upload-download-icon"
          [attr.aria-label]="'admin.global.download' | translate"
          (click)="downloadFile()"
          (keydown.enter)="downloadFile()"
          (keydown.space)="downloadFile()"
        ></i>
        <app-loading-panel
          [showLoading]="isUploading"
          [variant]="'overlay'"
          [hideText]="false"
        >
        </app-loading-panel>
      </div>
      <div>
        <app-explanation class="not-subscribed-text">{{
          infoMessage
        }}</app-explanation>
      </div>
    </div>
  </div>
</div>
